module.exports = __webpack_public_path__ + "media/steward_kate.da6295ae.mp3";